import { render, staticRenderFns } from "./OAuthLinkPrompt.vue?vue&type=template&id=18c28e23"
import script from "./OAuthLinkPrompt.vue?vue&type=script&lang=js"
export * from "./OAuthLinkPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports